import React from 'react';
import { PencilIcon, Trash2Icon } from 'lucide-react';
import type { CaseEntry } from '../../../types/caseEntry';
import { entryLabel, entrySubtotal, formatEntryDate } from '../../../utils/caseEntries';
import { formatHours, formatQuantity } from '../../../utils/caseEstimate';
import { formatKr } from '../../../utils/quote';
interface EntryRowProps {
  entry: CaseEntry;
  /** Vis en lille typelabel (Kørsel & service og Øvrigt). */
  showLabel?: boolean;
  onEdit: (entry: CaseEntry) => void;
  onDelete: (entry: CaseEntry) => void;
}

/** Én registreret linje: "dato — beskrivelse — mængde", med ret og slet. */
export function EntryRow({
  entry,
  showLabel = false,
  onEdit,
  onDelete
}: EntryRowProps) {
  const {
    label,
    text
  } = entryLabel(entry);
  const amount = entry.type === 'Timer' ? formatHours(entry.quantity) : entry.unit === 'fast pris' && entry.quantity === 1 ? formatKr(entrySubtotal(entry)) : `${formatQuantity(entry.quantity)} ${entry.unit}`;
  const showSum = entry.type !== 'Timer' && !(entry.unit === 'fast pris' && entry.quantity === 1);
  return <li className="flex items-center gap-3 py-2.5" data-id="element-181" data-mp="2picmuw8a1f4q">
      <div className="min-w-0 flex-1" data-id="element-182" data-mp="2phjc7k6765hb">
        <p className="flex min-w-0 items-center gap-2 text-[15px] text-ink" data-id="element-183" data-mp="2lgzd4b22crsj">
          {showLabel && <span className="shrink-0 rounded-md bg-canvas-deep px-1.5 py-0.5 text-[11px] font-medium text-ink-soft" data-id="element-184" data-mp="2giphjzcffp6e">
              {label}
            </span>}
          <span className="truncate" data-id="element-185" data-mp="3da9k9iazc4mb">{showLabel ? text : entry.description}</span>
        </p>
        {entry.date && <p className="text-xs text-ink-muted" data-id="element-186" data-mp="34g4yhdapdjdn">{formatEntryDate(entry.date)}</p>}
      </div>
      <div className="shrink-0 text-right" data-id="element-187" data-mp="34ds94f2m86qk">
        <p className="whitespace-nowrap text-[15px] font-medium text-ink" data-id="element-188" data-mp="2zfz4hqgynkse">{amount}</p>
        {(showSum || entry.type === 'Timer') && <p className="whitespace-nowrap text-xs text-ink-muted" data-id="element-189" data-mp="t4nhojnzk9q">{formatKr(entrySubtotal(entry))}</p>}
      </div>
      <div className="flex shrink-0" data-id="element-190" data-mp="ewk2flw723x2">
        <button type="button" onClick={() => onEdit(entry)} aria-label={`Ret ${entry.description}`} className="inline-flex h-10 w-10 items-center justify-center rounded-lg text-ink-faint transition-colors duration-150 hover:bg-canvas-deep hover:text-ink" data-id="element-191" data-mp="exlhe1gbzak2">
          <PencilIcon className="h-4 w-4" aria-hidden="true" data-id="element-192" data-mp="a4iwehpmd9fh" />
        </button>
        <button type="button" onClick={() => onDelete(entry)} aria-label={`Slet ${entry.description}`} className="inline-flex h-10 w-10 items-center justify-center rounded-lg text-ink-faint transition-colors duration-150 hover:bg-canvas-deep hover:text-danger" data-id="element-193" data-mp="3sb6zk213zmii">
          <Trash2Icon className="h-4 w-4" aria-hidden="true" data-id="element-194" data-mp="3ndev68ja27xf" />
        </button>
      </div>
    </li>;
}